import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { fetchAuthSession } from 'aws-amplify/auth';
// import { RolesType } from '../interfases/role.interface';

@Injectable({
    providedIn: 'root',
})
export class AuthService {

    private _isAuthSource$ = new BehaviorSubject<boolean>(false);

    isAuth$ = this._isAuthSource$.asObservable();

    // rol: RolType = 'Admin';

    async hasValidSession(): Promise<boolean> {
        try {
            const session = await fetchAuthSession();
            const hasValidTokens = Boolean(session.tokens?.accessToken && session.tokens?.idToken);
            this.setAuthenticated(hasValidTokens);
            return hasValidTokens;
        } catch {
            this.setAuthenticated(false);
            return false;
        }
    }

    login() {
        this.setAuthenticated(true);
    }

    logout() {
        this.setAuthenticated(false);
    }

    private setAuthenticated(isAuthenticated: boolean) {
        this._isAuthSource$.next(isAuthenticated);
    }
}
